import { InsuranceMonitorConfiguration } from "@wingspanhq/wingspan-api-sdk";

import { ExtendedRequirementDefinition } from "../../../../../query/requirementDefinitions/query/useQueryExtendedRequirementDefinition";
import { getRequirementDefinitionTemplateByParams } from "../../../../RequirementDefinitions/utils";

import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";

export const selectorTemplateParamsFromExtendedRequirementDefinition = (
  requirement: ExtendedRequirementDefinition
): Parameters<typeof getRequirementDefinitionTemplateByParams>[0] => {
  return {
    type: requirement.type!,
    contextType: requirement?.dataSourceSettings?.contextType,
    policyType: selectorPolicyTypesFromSettings(
      requirement?.dataSourceSettings as InsuranceMonitorConfiguration
    )
  };
};
